export class MDCentralGovernmentBodyModel {
    constructor(
        public nameAsOnCertificate: string,
        public isStampReadable: string,
        public isStampOfCompetentAuthority: string,
        public isSignaturePresent: string,
        public isRetirementDateWithinLimit: string,
        public isStaffQuarterAllotted: string,
        public isDateOfIssuePresent: string,
        // public isQRCodePresent: string,
    ) { }
}